import React from "react";

import "./about.css";

import { Link } from "react-scroll";

import { aboutImage } from "../../data";

const About = () => {
  return (
    <section className="about_section" id="about">
      <div className="about_container">
        <div className="about_body">
          <img className="about_left_image" src={aboutImage} alt="" />
          <div className="about_details">
            <div className="about_details_right">
              <h1>About me</h1>
              <h5>Security Research Team Lead 🔹 Software Engineer</h5>

              <hr />
                
              <p className="about_descriptions">
                Hi, my name is Haim Azulay. I&apos;m a Security Research Team Lead and Software Engineer with a strong passion for information security.
                <br />
                I completed my Software Engineering studies at Braude College, where I built a solid foundation in software development and system design.
                <br />
                Along the way, I chose to specialize in cybersecurity, taking a dedicated cyber and ethical hacking course at John Bryce College to deepen my practical skills.
                <br />
                Today, I lead a Security Research team, focusing on analyzing threats, discovering vulnerabilities, and helping to design resilient, real-world security solutions.
                <br />
                <br />
                If you&apos;d like to learn more or receive my resume, feel free to contact me using the button below.
              </p>

            </div>
            <button className="btn_md">
              <Link
                to="contact"
                activeClass="active"
                spy={true}
                smooth={true}
                duration={500}
                offset={-70}
              >
                Contact me
              </Link>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
